import React from "react";
import PropTypes from "prop-types";

import styles from "./NoResults.css";

export default function NoResults({ lookup }) {

  return (
    <p className={styles.root}>
      Your search for “{lookup}” did not match any results.
    </p>
  );
  
}

NoResults.propTypes = {
  lookup: PropTypes.string.isRequired,
};
